import { render } from "./AccountPageUpdate.vue?vue&type=template&id=428a1254&scoped=true"
import script from "./AccountPageUpdate.vue?vue&type=script&lang=js"
export * from "./AccountPageUpdate.vue?vue&type=script&lang=js"

import "./AccountPageUpdate.vue?vue&type=style&index=0&id=428a1254&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428a1254"]])

export default __exports__